import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * query transcription bucket temp credentials
 */
export default async function queryTranscriptionBucketTempCredentials() {
  const res = await fetchOrchidAPI(
    `/api/scheduler/v1/transcription/transcription-bucket-temp-credentials`,
  );
  if (!res.ok) {
    throw new Error(
      `failed to get transcription: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
